{
  "button": {
    "hide": "Ẩn",
    "show": "Hiện",
    "rememberMe": "Ghi nhớ đăng nhập",
    "forgotPassword": "Quên mật khẩu",
    "termsAndConditions": "Điều khoản và điều kiện",
    "seeMore": "Xem Thêm",
    "search": "Tìm Kiếm"
  },
  "title": {
    "signin": "Đăng nhập",
    "signingIn": "Đang đăng nhập",
    "loginWithOtherAccount": "Đăng nhập bằng tài khoản khác",
    "continueWithGG": "Tiếp tục với Google",
    "signUp": "Đăng ký",
    "signingUp": "Đang đăng ký",
    "continueWithKaKao": "Tiếp tục với KaKaoTalk",
    "home": "Trang chủ",
    "tours": "Tour",
    "aboutUs": "Về chúng tôi",
    "dashboard": "Bảng điều khiển",
    "myProfile": "Hồ sơ của tôi",
    "signout": "Đăng xuất",
    "customerSupport": "Hỗ trợ khách hàng",
    "dropUsAnEmail": "Gửi email cho chúng tôi",
    "locations": "Địa điểm",
    "followUsOn": "Theo dõi chúng tôi trên"
  },
  "msg": {
    "registeredSuccess": "Đăng ký thành công"
  },
  "valid": {
    "required": "Trường này là bắt buộc",
    "requiredInfor": "Thông tin không hợp lệ. Vui lòng nhập lại.",
    "passwordsDoNotMatch": "Mật khẩu không khớp",
    "mustAcceptTerms": "Bạn cần chấp nhận điều khoản và điều kiện để tiếp tục."
  },
  "field": {
    "phone": "Số điện thoại",
    "password": "Mật khẩu",
    "confirmPassword": "Xác nhận mật khẩu",
    "userName": "Họ và tên",
    "email": "Email"
  },
  "or": "Hoặc",
  "noAccount": "Chưa có tài khoản",
  "haveAccount": "Đã có tài khoản",
  "accept": "Chấp nhận",
  "footerSlogan": "Sứ mệnh của chúng tôi là mang đến cho bạn một trải nghiệm du lịch liền mạch và thú vị, dù bạn đang lên kế hoạch cho một kỳ nghỉ thư giãn, một cuộc phiêu lưu đầy hứng khởi, hay một tour du lịch đáng nhớ cùng những người thân yêu.",
  "whereDoYouWantToGo?": "Bạn muốn đi đâu?",
  "departureDate": "Ngày khởi hành",
  "travellerroom": "Hành khách & Phòng"
}
